import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';
const SvgIcon = createSvgIcon([
    React.createElement("circle", { key: '0', fill: '#000000', cx: '12', cy: '12', r: '12' }),
    React.createElement("circle", { key: '1', fill: '#FFFFFF', cx: '12', cy: '12', r: '10' }),
    React.createElement("path", { key: '2', fill: '#000000', d: 'M10.7,6.3h2.7C13.7,6.3,14,6,14,5.7C14,5.3,13.7,5,13.3,5h-2.7C10.3,5,10,5.3,10,5.7C10,6,10.3,6.3,10.7,6.3z' }),
    React.createElement("path", { key: '3', fill: '#000000', d: 'M16.7,9.3l0.5-0.5c0.3-0.3,0.3-0.7,0-0.9l0,0c-0.3-0.3-0.7-0.3-0.9,0l-0.5,0.5C14.7,7.5,13.4,7,12,7c-3.2,0-5.9,2.6-6,5.8\n\t\tC5.9,16.2,8.6,19,12,19c3.3,0,6-2.7,6-6C18,11.6,17.5,10.3,16.7,9.3z M12.7,13c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7v-2.7\n\t\tc0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7V13z' }),
], 'TransportConditionGeofenceControl');
const TransportConditionGeofenceControlIcon = function (props) {
    return React.createElement(SvgIcon, Object.assign({}, props));
};
export default memo(TransportConditionGeofenceControlIcon);
